const ZERO_TOTALS = {
  runs: 0,
  api_calls: 0,
  input_tokens: 0,
  output_tokens: 0,
  cache_read_tokens: 0,
  cache_write_tokens: 0,
  reasoning_tokens: 0,
  total_tokens: 0,
}

/** The shape used when the API is absent or usage tracking is off. */
export function emptyUsageSummary() {
  return {
    configured: false,
    range: { since: '', until: '' },
    totals: { ...ZERO_TOTALS },
    series: [],
  }
}

/** Compact token count: 1_234_567 → "1.2M". */
export function formatTokens(value) {
  const count = Number(value) || 0
  if (count >= 1_000_000) return `${(count / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`
  if (count >= 1_000) return `${(count / 1_000).toFixed(1).replace(/\.0$/, '')}K`
  return String(count)
}
